import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { PDP_READYTOSHIP_TAB_ID, PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import PDPChooseYourOptionsUIInner from './PDPChooseYourOptionsUI';
import usePDPOptions from '../state/context/usePDPOptions';
import usePDPStockAvailability from '../state/context/usePDPStockAvailability';
import PDPChooseYourOptionsPlaceholder from './PDPChooseYourOptionsPlaceholder';
const PDPChooseYourOptionsInner = t0 => {
  const $ = _c(27);
  const {
    isEditOrder: t1,
    mode: t2,
    onMoreMaterialsClick,
    setMarxentSelectedFabric,
    slug,
    isLayoutRevamp: t3
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const isLayoutRevamp = t3 === undefined ? false : t3;
  const {
    loading: basicDetailsLoading,
    data: basicDetailsData
  } = usePDPBasicDetails();
  const {
    loading,
    data: t4
  } = usePDPOptions();
  let t5;
  if ($[0] !== t4) {
    t5 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const {
    options: t6,
    upholsteryOptionId,
    stock: t7
  } = t5;
  let t8;
  if ($[2] !== t6) {
    t8 = t6 === undefined ? [] : t6;
    $[2] = t6;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const options = t8;
  let t9;
  if ($[4] !== t7) {
    t9 = t7 === undefined ? {} : t7;
    $[4] = t7;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const stock = t9;
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const {
    data: t10
  } = usePDPStockAvailability();
  const {
    isMarkedOOSOrDiscontinued,
    isStockLoading
  } = t10;
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  let t11;
  if ($[6] !== basicDetailsData) {
    t11 = basicDetailsData ?? {};
    $[6] = basicDetailsData;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  const {
    id,
    efg_flag,
    custom_properties: t12
  } = t11;
  let t13;
  if ($[8] !== t12) {
    t13 = t12 === undefined ? {} : t12;
    $[8] = t12;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  const {
    option_selector: t14
  } = t13;
  const optionSelector = t14 === undefined ? "" : t14;
  const isRTSTab = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID;
  const isDecideLaterTab = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const t15 = !efg_flag;
  const t16 = loading || basicDetailsLoading || isMarkedOOSOrDiscontinued && isStockLoading;
  const t17 = isRTSTab ? stock?.stockOptions : options;
  const t18 = stock?.selectionValidity;
  let t19;
  if ($[10] !== id || $[11] !== isDecideLaterTab || $[12] !== isEditOrder || $[13] !== isLayoutRevamp || $[14] !== isRTSTab || $[15] !== mode || $[16] !== onMoreMaterialsClick || $[17] !== optionSelector || $[18] !== pdpIsModularBYOProduct || $[19] !== setMarxentSelectedFabric || $[20] !== slug || $[21] !== t15 || $[22] !== t16 || $[23] !== t17 || $[24] !== t18 || $[25] !== upholsteryOptionId) {
    t19 = <PDPChooseYourOptionsUIInner pdpIsModularBYOProduct={pdpIsModularBYOProduct} isDecideLaterTab={isDecideLaterTab} isEditOrder={isEditOrder} isFFG={t15} isRTSTab={isRTSTab} loading={t16} mode={mode} onMoreMaterialsClick={onMoreMaterialsClick} options={t17} productId={id} selectionValidity={t18} slug={slug} optionSelector={optionSelector} upholsteryOptionId={upholsteryOptionId} setMarxentSelectedFabric={setMarxentSelectedFabric} isLayoutRevamp={isLayoutRevamp} />;
    $[10] = id;
    $[11] = isDecideLaterTab;
    $[12] = isEditOrder;
    $[13] = isLayoutRevamp;
    $[14] = isRTSTab;
    $[15] = mode;
    $[16] = onMoreMaterialsClick;
    $[17] = optionSelector;
    $[18] = pdpIsModularBYOProduct;
    $[19] = setMarxentSelectedFabric;
    $[20] = slug;
    $[21] = t15;
    $[22] = t16;
    $[23] = t17;
    $[24] = t18;
    $[25] = upholsteryOptionId;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  return t19;
};
PDPChooseYourOptionsInner.propTypes = {
  isEditOrder: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  setMarxentSelectedFabric: PropTypes.func,
  slug: PropTypes.string,
  isLayoutRevamp: PropTypes.bool
};
const PDPChooseYourOptions = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPChooseYourOptionsPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPChooseYourOptionsInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPChooseYourOptions;